import http from "@/api/http";
import type { ShippingDirection } from "@/contexts/DirectionContext";

/** Tipurile de mesaj — oglindite în backendul portalului (modules/contact) și în aplicația principală (modules/portal-contact). */
export const CONTACT_MESSAGE_TYPES = [
  "error",
  "suggestion",
  "question",
  "other",
] as const;
export type ContactMessageType = (typeof CONTACT_MESSAGE_TYPES)[number];
export const CONTACT_MESSAGE_MIN = 5;
export const CONTACT_MESSAGE_MAX = 5000;

export interface SendContactMessage {
  type: ContactMessageType;
  message: string;
  companyId?: number;
  direction?: ShippingDirection;
}

export const contactApi = {
  async status(): Promise<{ enabled: boolean }> {
    const response = await http.get("/contact/status");
    return (response.data?.data ?? response.data) as { enabled: boolean };
  },

  async send(payload: SendContactMessage): Promise<void> {
    await http.post("/contact", payload);
  },
};
